import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.914",
  height: "14.914"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "#474d58",
      "stroke-linecap": "round"
    }, [
      _createElementVNode("path", { d: "m.707 13.707 13-13M5.207 14.207l9-9" })
    ], -1)
  ]))]))
}
export default { render: render }